const selectors = {
    readMoreBtn: document.querySelectorAll('[data-more-btn]'),
    filterSearch: document.querySelectorAll('[data-title]'),
    /* Events Inpage Search Functionality */
    searchbox : document.querySelector('[data-event-searchEvent]'),
    all_blocks :  document.querySelectorAll('[data-event-block]'),
    no_results : document.querySelector('[data-noresults]'),
     /* Copy EventLink Functionality */
    alllinks : document.querySelectorAll('[data-copyEventsLink]')
};
class upcomingEeventsJS {
    constructor() {
        this.readMore();
        this.searchText();
        this.eventLinkCopy();
    }
    readMore(){
        selectors.readMoreBtn.forEach(element => {
            if(element){
                element.addEventListener('click', (e)=>{
                    e.preventDefault();e.stopImmediatePropagation();
                    let currentTarget = e.target;
                        if(currentTarget.closest('[data-readmorecontainer]').classList.contains('open')){
                            Utility.toggleElement(currentTarget.closest('[data-readmorecontainer]'), 'close');
                            element.querySelector('[data-readmore]').classList.toggle('d-none');
                            element.querySelector('[data-readless]').classList.toggle('d-none');
                        }else{
                            Utility.toggleElement(currentTarget.closest('[data-readmorecontainer]'), 'open');
                            element.querySelector('[data-readmore]').classList.toggle('d-none');
                            element.querySelector('[data-readless]').classList.toggle('d-none');
                        }
                });
            }
        });
    }
    /* Events Inpage Search Functionality */
    searchText(){
        if(selectors.all_blocks.length){
            selectors.searchbox.addEventListener('input', (e)=>{
                e.preventDefault()
                let term = selectors.searchbox.value.toLowerCase();
                selectors.all_blocks.forEach(block=>{
                    let block_title = block.dataset.title;
                    if (block_title.includes(term)) {
                        block.classList.remove('d-none');
                    } else {
                        block.classList.add('d-none');
                    }
                });
                    if (!(document.querySelectorAll('[data-event-block]:not(.d-none)').length)){  
                        selectors.no_results.classList.remove('d-none');
                    } else {                
                        selectors.no_results.classList.add('d-none');
                    }
            });
        }
    }
    /* Copy EventLink Functionality */
    eventLinkCopy(){
        if(selectors.alllinks.length){
            selectors.alllinks.forEach(f=>{ 
                f.addEventListener('click',(e)=>{
                    let link = f.dataset.link;
                    if(link !='' && link != undefined){
                        navigator.clipboard.writeText(link); 
                        f.querySelector('.shareLinkText').innerText='Event Link Copied';
                        setTimeout(()=>{f.querySelector('.shareLinkText').innerText='Share this Event'},4000);
                    }
                })
            })
        }
    }

}

typeof upcomingEeventsJS !== 'undefined' && new upcomingEeventsJS();
